import monitoring from './pages/monitoring';
import management from './pages/management';
import overview from './pages/overview';
import system from './pages/system';
import user from './pages/user';
import platform from './pages/platform';
import admin from './pages/admin';
import ai from './pages/ai';
import misc from './pages/misc';
import moduleI18n from './pages/module';

const pages = {
  monitoring,
  management,
  overview,
  system,
  user,
  platform,
  admin,
  ai,
  ...misc,
  ...moduleI18n,
};

export default pages;
